import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=cecc8dca&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"
import style0 from "./advertising.vue?vue&type=style&index=0&id=cecc8dca&prod&lang=scss&scoped=true"
import style1 from "./advertising.vue?vue&type=style&index=1&id=cecc8dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecc8dca",
  null
  
)

export default component.exports